export const filterPayload = <T extends object, K extends keyof T>(payload: T, keys: K[]): Pick<T, K> => {
  const result = {} as Pick<T, K>;

  keys.forEach(key => {
    if (key in payload) {
      if (payload[key] !== '') {
        result[key] = payload[key];
      }
    }
  });

  return result;
}